import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-confirm-action-modal',
  imports: [],
  template: `
    @if (show()) {
      <div class="fixed inset-0 z-[99999] flex items-center justify-center">
        <div
          class="absolute inset-0 bg-black/20 transition-opacity z-[99998]"
          (click)="onCancel()"
        ></div>
        <div class="bg-white dark:bg-slate-800 rounded-2xl p-6 max-w-md w-full z-[99999] mx-4">
          <h3 class="text-xl font-bold text-gray-900 dark:text-white mb-4">{{ title() }}</h3>
          <p class="text-gray-600 dark:text-gray-400 mb-6">{{ message() }}</p>
          <div class="flex gap-3">
            <button
              (click)="onCancel()"
              class="flex-1 px-4 py-2 bg-gray-100 dark:bg-slate-800 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-200 dark:hover:bg-slate-600 dark:bg-slate-700 transition"
            >
              {{ cancelLabel() }}
            </button>
            <button
              (click)="onConfirm()"
              class="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
            >
              {{ confirmLabel() }}
            </button>
          </div>
        </div>
      </div>
    }
  `,
  styles: [
    `
      @keyframes fade-in {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }
      @keyframes zoom-in-95 {
        from {
          transform: scale(0.95);
          opacity: 0;
        }
        to {
          transform: scale(1);
          opacity: 1;
        }
      }
      .animate-in {
        animation:
          fade-in 0.2s ease-out,
          zoom-in-95 0.2s ease-out;
      }
    `,
  ],
})
export class ConfirmActionModalComponent {
  readonly show = input<boolean>(false);
  readonly title = input<string>('Confirmer');
  readonly message = input<string>('');
  readonly confirmLabel = input<string>('Confirmer');
  readonly cancelLabel = input<string>('Annuler');

  readonly confirm = output<void>();
  readonly cancel = output<void>();

  onConfirm() {
    this.confirm.emit();
  }

  onCancel() {
    this.cancel.emit();
  }
}
